import React, { useEffect, useState } from 'react';
import { fetchAemPageContent, useEventListener, setConfigs } from '@msc-b2c/shared-utils';
import { AEMComponentRenderer } from '@msc-b2c/shared-components';
import { TransformedNode } from '@msc-b2c/interfaces/interfaces';
import { wrappers } from './wrappers';
import { useDispatch } from 'react-redux';

export function App() {
  const [aemData, setAemData] = useState<TransformedNode>();

  const dispatch = useDispatch();

  useEventListener(globalThis, 'author-content-update', () => {
    fetchAemPageContent(globalThis.location.href).then((data) => {
      data && setAemData(data);
    });
  });

  useEffect(() => {
    fetchAemPageContent(globalThis.location.href).then((data) => {
      data && setAemData(data);
      dispatch(setConfigs(data?.properties?.configs));
      return () => {};
    });
  }, [dispatch]);

  return (
    <AEMComponentRenderer
      aemDataRoot={aemData}
      wrappers={wrappers}
    />
  );
}

export default App;
